/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file
import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen
const splashScreen = {
  enabled: false, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section
const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Alexander Marinkovich",
  title: "Hey, I'm Alex",
  subTitle: emoji(
    "Data Scientist and Software Engineer who loves building scalable web apps, AI-driven tools, and innovative games that keep players hooked."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1ofFdKF_mqscH8WvXkSObnVvC9kK7Ldlu/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links
const socialMediaLinks = {
  github: "https://github.com/AlexMarinkovich",
  linkedin: "https://www.linkedin.com/in/alex-marinkovich/",
  gmail: "alex-989@live.com",
  // All options: github, linkedin, gmail, facebook, instagram, twitter, reddit, medium, stackoverflow, youtube, twitch, dev.to
  display: true // Set true to display this section, defaults to false
};

// Skills Section
const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "swift",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Education Section
const educationInfo = {
  display: false, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Harvard University",
      logo: require("./assets/images/queensUniversityLogo.jpg"),
      subHeader: "Master of Science in Computer Science",
      duration: "September 2017 - April 2019",
      desc: "Participated in the research of XXX and published 3 papers.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      schoolName: "Stanford University",
      logo: require("./assets/images/queensUniversityLogo.jpg"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "September 2013 - April 2017",
      desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
      descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Work experience section
const workExperiences = {
  title: "Work Experience",
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Teaching Assistant",
      company: "Queen’s University",
      companylogo: require("./assets/images/queensUniversityLogo.jpg"),
      date: "Sep. 2026 – Dec. 2025",
      desc: "Graded assignments and hosted weekly office hours to assist students in in the Discrete Math course."
    },
    {
      role: "Data Scientist Intern",
      company: "Scotiabank",
      companylogo: require("./assets/images/scotiabankLogo.jpg"),
      date: "May 2025 – Apr. 2026",
      desc: "Automated the generation of quarterly financial reports.",
      descBullets: []
    },
    {
      role: "Teaching Assistant",
      company: "Queen’s University",
      companylogo: require("./assets/images/queensUniversityLogo.jpg"),
      date: "Jan. 2025 – Apr. 2025",
      desc: "Graded assignments and hosted weekly office hours to assist students in in the Data Structures course."
    },
    {
      role: "Software Engineer Intern",
      company: "Scotiabank",
      companylogo: require("./assets/images/scotiabankLogo.jpg"),
      date: "May 2024 – Aug. 2024",
      desc: "Leveraged Generative AI to summarize, compare, and assess risks in qualitative financial data"
    }
  ]
};

// Achievement Section
// Include certificates, talks etc
const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/queensUniversityLogo.jpg"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-0000000000",
  email_address: "alex-989@live.com",
  display: false // Set false to hide this section, defaults to true
};

// Twitter Section
const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const displayHeader = true; // Set to false to hide header
const displayFooter = false; // Set to false to hide footer

// My Project Showcase Section
const showcaseProjects = {
  title: "Project Showcase",
  subtitle: "Hover over a project to see a preview!",
  display: true,
  projects: [
    {
      image: require("./assets/images/mctraps-icon.png"),
      video: require("./assets/videos/mctraps-preview.mp4"),
      title: "MCTraps.com",
      description:
        "A full-stack web platform that teaches Minecraft players how to build traps, with over 10k monthly visitors.",
      link: "https://mctraps.com/"
    },
    {
      image: require("./assets/images/the-detonator-icon.png"),
      video: require("./assets/videos/the-detonator-preview.mp4"),
      title: "The Detonator",
      description:
        "A physics game featuring levels in which the player must use the blast waves of explosives to launch themself through tricky terrain.",
      source: "https://github.com/AlexMarinkovich/The-Detonator",
      download: "https://github.com/AlexMarinkovich/The-Detonator/releases"
    },
    {
      image: require("./assets/images/airstrike-logo.png"),
      video: require("./assets/videos/airstrike-preview.mp4"),
      title: "Airstrike",
      description:
        "Control a tank and survive as long as you can throughout the airstrike. Inspired by the game Heavy Weapon.",
      source: "https://github.com/AlexMarinkovich/Airstrike",
      download: "https://github.com/AlexMarinkovich/Airstrike/releases"
    },
    {
      image: require("./assets/images/maze-runner-icon.png"),
      video: require("./assets/videos/maze-runner-preview.mp4"),
      title: "Maze Runner",
      description:
        "Race through randomly generated mazes that can change state. Go up against the clock, another person, or the computer, and save your highscores.",
      source: "https://github.com/AlexMarinkovich/Maze_Runner",
      download: "https://github.com/AlexMarinkovich/Maze_Runner/releases"
    },
    {
      image: require("./assets/images/geometry-wars-icon.png"),
      video: require("./assets/videos/geometry-wars-preview.mp4"),
      title: "Geometry Wars",
      description:
        "A recreation of the retro game Geometry Wars, with the addition of spaceship upgrades! Survive as long as you can against the endless waves of enemies.",
      source: "https://github.com/AlexMarinkovich/Geometry_Wars",
      download: "https://github.com/AlexMarinkovich/Geometry_Wars/releases"
    }
  ]
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  workExperiences,
  achievementSection,
  contactInfo,
  twitterDetails,
  displayHeader,
  displayFooter,
  showcaseProjects
};
